import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryHover, header } from '../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	buttonRow: {
		display: 'flex',
		gap: 12,
		justifyContent: 'flex-end',
		marginTop: 24,
	},
	cancelButton: {
		':hover': {
			background: '#f0f0f0',
		},
		background: '#fff',
		border: '1px solid #D3DBDE',
		borderRadius: 6,
		cursor: 'pointer',
		fontSize: 14,
		padding: '10px 20px',
		transition: 'background 0.2s',
	},
	closeButton: {
		':hover': {
			background: brandPrimaryHover,
		},
		background: brandPrimary,
		border: 'none',
		borderRadius: 6,
		color: '#fff',
		cursor: 'pointer',
		fontSize: 14,
		marginTop: 16,
		padding: '10px 20px',
		transition: 'background 0.2s',
	},
	container: {
		maxHeight: '80vh',
		maxWidth: 600,
		overflowY: 'auto',
		padding: 24,
	},
	downloadButton: {
		':hover': {
			background: '#f0f0f0',
		},
		background: '#fff',
		border: '1px solid #D3DBDE',
		borderRadius: 6,
		color: header,
		padding: '10px 20px',
		textDecoration: 'none',
		transition: 'background 0.2s',
	},
	downloadButtons: {
		display: 'flex',
		gap: 12,
		justifyContent: 'center',
		marginTop: 16,
	},
	fileName: {
		color: header,
		fontSize: 14,
		marginTop: 8,
		textAlign: 'center',
	},
	formGroup: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 16,
	},
	formSection: {
		marginTop: 24,
	},
	generateButton: {
		':hover': {
			background: brandPrimaryHover,
		},
		alignItems: 'center',
		background: brandPrimary,
		border: 'none',
		borderRadius: 6,
		color: '#fff',
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		gap: 8,
		padding: '10px 20px',
		transition: 'background 0.2s',
	},
	input: {
		border: '1px solid #D3DBDE',
		borderRadius: 4,
		fontSize: 14,
		padding: '8px 12px',
	},
	label: {
		color: header,
		fontSize: 14,
		fontWeight: 'bold',
		marginBottom: 8,
	},
	priceSummary: {
		background: '#f8f9fa',
		border: '1px solid #D3DBDE',
		borderRadius: 8,
		display: 'flex',
		flexDirection: 'column',
		fontSize: 14,
		gap: 8,
		marginTop: 16,
		padding: 16,
	},
	proposalTypeSection: {
		display: 'flex',
		gap: 24,
		marginTop: 16,
	},
	radioLabel: {
		alignItems: 'center',
		color: header,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		gap: 8,
	},
	sectionTitle: {
		color: header,
		fontSize: 16,
		fontWeight: 'bold',
		marginBottom: 16,
	},
	select: {
		border: '1px solid #D3DBDE',
		borderRadius: 4,
		fontSize: 14,
		padding: '8px 12px',
	},
	successSection: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		marginTop: 24,
		textAlign: 'center',
	},
	successTitle: {
		color: '#4caf50',
		fontSize: 18,
		fontWeight: 'bold',
		marginTop: 0,
	},
	title: {
		color: header,
		fontSize: 20,
		fontWeight: 'bold',
		marginTop: 0,
	},
});
